import { GAME_CONFIG } from '../config/gameConfig';

export interface AccuracyResult {
  accuracy: number;
  distance: number;
  targetX: number;
}

export class AccuracySystem {
  private targetX: number;
  private maxDistance: number;

  constructor(targetX: number, maxDistance: number) {
    this.targetX = targetX;
    this.maxDistance = maxDistance;
  }

  calculate(craneX: number, platform: 'desktop' | 'mobile'): AccuracyResult {
    const distance = Math.abs(craneX - this.targetX);
    let accuracy = Math.max(0, 1 - distance / this.maxDistance);

    if (platform === 'mobile') {
      accuracy = 0.5 + accuracy * 0.5;
    }

    return { accuracy, distance, targetX: this.targetX };
  }

  updateTarget(targetX: number): void {
    this.targetX = targetX;
  }
}

export function getBaseRate(version: string): number {
  return GAME_CONFIG.baseRates[version] ?? GAME_CONFIG.successRate;
}
